module.exports = {
  buildVersion: "0.1.1",
  buildDate: 1724656272274,
}